import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Péptidos Costa Rica";
const SITE_URL = "https://peptidoscostarica.com";
const DEFAULT_DESC =
  "Compra local de péptidos sintéticos de alta pureza en Costa Rica: BPC-157, TB-500, GHK-Cu, Tirzepatide y más. Envío directo, sin aduana.";
const DEFAULT_IMAGE = `${SITE_URL}/api/og-image.svg`;
const DEFAULT_KEYWORDS =
  "péptidos Costa Rica, péptidos sintéticos, compra local péptidos, BPC-157, TB-500, GHK-Cu, Tirzepatide, Retatrutide, envío directo Costa Rica";

const Seo = ({
  title,
  description,
  canonical,
  jsonLd,
  image,
  noindex,
  keywords,
  type = "website",
  publishedAt,
  modifiedAt,
  author,
  breadcrumbs,
}) => {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Compra Local`;
  const desc = description || DEFAULT_DESC;
  const url = canonical || SITE_URL;
  const og = image || DEFAULT_IMAGE;
  const kw = keywords || DEFAULT_KEYWORDS;

  // Always inject a BreadcrumbList if breadcrumbs are provided
  const breadcrumbJsonLd = breadcrumbs && breadcrumbs.length > 0 && {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbs.map((b, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: b.name,
      item: b.url.startsWith("http") ? b.url : `${SITE_URL}${b.url}`,
    })),
  };

  return (
    <Helmet prioritizeSeoTags>
      <html lang="es-CR" />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      <meta name="author" content={author || SITE} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      <meta name="googlebot" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <meta name="bingbot" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <meta name="format-detection" content="telephone=no" />

      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang="es-cr" href={url} />
      <link rel="alternate" hrefLang="es" href={url} />
      <link rel="alternate" hrefLang="x-default" href={url} />

      {/* Open Graph */}
      <meta property="og:locale" content="es_CR" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={og} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={fullTitle} />
      {publishedAt && <meta property="article:published_time" content={publishedAt} />}
      {modifiedAt && <meta property="article:modified_time" content={modifiedAt} />}
      {author && type === "article" && <meta property="article:author" content={author} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@peptidoscostarica" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={og} />
      <meta name="twitter:image:alt" content={fullTitle} />

      {/* Geo */}
      <meta name="geo.region" content="CR" />
      <meta name="geo.country" content="Costa Rica" />
      <meta name="geo.placename" content="San José" />
      <meta name="ICBM" content="9.9281,-84.0907" />

      {/* JSON-LD blocks */}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
      {breadcrumbJsonLd && <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
